var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TabBasic',{ref:"tabBasic",attrs:{"actual-breadcrumb":_vm.actualBreadcrumb,"show-breadcrumbs":""}},[_c('AlertHistory',{attrs:{"user-id":_vm.$store.getters.getUserId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }